(function($) {

	$.fn.initFooter = function() {

		var _this = this;

		_this.find('a[href="#top"]').click(function() {

			$('html, body').animate({
				scrollTop: 0
			}, 500);
			return false;

		});

		/*

		_this.find('.contact, .social, .cocoa-bg').addClass('preparing').waypoint(function() {
			$(this.element).removeClass('preparing');
		}, {
			offset: function() {
				return Waypoint.viewportHeight() - ($(this.element).height() * 0.4);
			}
		});

		_this.find('.cocoa-bg').waypoint(function(direction) {
			if (direction == 'up') {
				$(this.element).addClass('light-preparing');
			} else {
				$(this.element).removeClass('light-preparing');
			}
		}, {
			offset: function() {
				return Waypoint.viewportHeight() - ($(this.element).height() * 0.9);
			}
		})

		window.setTimeout(function() {
			_this.addClass('animated');
		}, 50);

		*/


		// Pokus s paralaxním footerem na pozadí

		// Automatické zvětšování spaceru
		var $footerSpace = $("#footer-space");
		var footerSpaceHeightAlt = parseInt($footerSpace.attr('data-height-alt')) || 0;

		function resizeFooterSpace() {
			var h = _this.outerHeight() - $('.c-curl').height() - footerSpaceHeightAlt;
			$footerSpace.outerHeight(h);
		}

		var throttledResizeFooterSpace = $.throttle(500, resizeFooterSpace);

		$(window).on('resize', throttledResizeFooterSpace);
		resizeFooterSpace();
		window.setTimeout(resizeFooterSpace, 200); // nějaký bug v safari

		// Nastavení třídy .can-be-hovered

		function checkWindowScrolling() {
			var $w = $(window);
			if ($w.scrollTop() > $(document.body).height() - _this.outerHeight() - window.innerHeight) {
				_this.addClass('can-be-hovered');
			} else {
				_this.removeClass('can-be-hovered');
			}
		}

		var throttledCheckWindowScrolling = $.throttle(250, checkWindowScrolling);
		$(window).on('scroll', throttledCheckWindowScrolling);
		checkWindowScrolling();


		// Stmívání

		function setBrightness() {
			var scrollFromBottom = $(document.body).height() - ($(window).scrollTop() + window.innerHeight);
			var footerHeight = _this.find('.pos').outerHeight();
			var visiblePart = 1 - (scrollFromBottom / footerHeight);
			if (visiblePart > 1) {
				visiblePart = 1;
			} else if (visiblePart < 0) {
				visiblePart = -1;
			}
			if (visiblePart >= 0 && visiblePart < 1) {
				var calcBrightness = Math.ceil(visiblePart * 100);
				_this.css('filter', 'brightness(' +  calcBrightness + '%)');
			} else {
				if (visiblePart == -1) {
					_this.css('filter', 'brightness(0%)');
				} else {
					_this.css('filter', 'none');
				}
			}
		}

		var throttledSetBrightness = $.throttle(300, setBrightness);
		$(window).on('scroll', throttledSetBrightness);
		setBrightness();



		return this;

	}

})(jQuery);
